<template>
    <!-- <el-radio-group v-model="dataName" size="middle">
      <el-radio-button value="ele1" label="可运营专利" />
      <el-radio-button value="ele2" label="重点专利" />
    </el-radio-group> -->
  <!-- <el-table :data="tableData1" height="200"  style="width: 100%" v-if="dataName==='ele1'" class="tablebox" tooltip-effect="dark myTooltips">
    <el-table-column prop="pubNumber" label="公开（公告）号" :show-overflow-tooltip="true" min-width="70"> 
      <template #default="scope">
        <a :href="scope.row.link" target="_blank" :style="{color:'#2C6AE8','textDecoration':'none'}">{{ scope.row.pubNumber }}</a>
      </template>
    </el-table-column>
    <el-table-column prop="title" label="标题"  :show-overflow-tooltip="true" min-width="120"> 
    </el-table-column>
    <el-table-column prop="apply" label="原始申请人" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="dever" label="发明人" :show-overflow-tooltip="true"> 
    </el-table-column>
  </el-table> -->
  <el-table :data="tableData2" height="180" style="width: 100%" :style="{marginTop: '15px'}" tooltip-effect="dark myTooltips" ref="myTable">
    <el-table-column prop="row1" label="公开（公告）号" :show-overflow-tooltip="true" min-width="150"> 
      <template #default="scope">
        <a :href="scope.row.link" target="_blank" :style="{color:'#2C6AE8','textDecoration':'none'}">{{ scope.row.row1 }}</a>
      </template>
    </el-table-column>
    <!-- <el-table-column prop="row2" label="申请号" :show-overflow-tooltip="true" min-width="180"> </el-table-column> -->
    <el-table-column prop="row4" label="标题" :show-overflow-tooltip="true" min-width="120"> 
    </el-table-column>
    <el-table-column prop="row3" label="申请日" :show-overflow-tooltip="true" min-width="120"> </el-table-column>
    <el-table-column prop="row5" label="当前申请(专利权)人" :show-overflow-tooltip="true" min-width="200">
     </el-table-column>
    <el-table-column prop="row6" label="法律有效性" :show-overflow-tooltip="true" min-width="120"> </el-table-column>
  </el-table>
</template>
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
export default {
  name: "echartsBox",
  data(){
    return {
      //  dataName: 'ele1',
    }
  },
  setup() {
    let timer = null;
    const myTable = ref(null);
    /// 声明定义一下echart
    const tableData2 = ref([
      {row1: 'CN105303526A',row2:'CN201510594428.8', row3: '2015-09-17',row4: '一种基于海岸线数据及频谱分析的舰船目标检测方法',row5: '哈尔滨工业大学|哈尔滨华凡传感技术有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-101434728-A&excelToken=new425BEA035449FE6CE88235178DE51B13A0C5C12315373AE82E6F4B3B1D9662DD_24D9087670099ADD93B19765F5E03444'},
      {row1: 'CN110044511A',row2:'CN201910350879.5', row3: '2019-04-28',row4: '一种采用非接触电极的高稳定长度伸缩模石英温度传感器',row5: '哈尔滨华凡传感技术有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-110044511-A&excelToken=newBF9DDC0D939774C1DA24E17B0D6C5F07EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN109580030A',row2:'CN201910023542.3', row3: '2019-01-10',row4: '一种具有多枚箭形振臂的高精度谐振式石英温度传感器',row5: 'HARBIN HUAFAN SENSING TECHNOLOGY CO.,LTD.',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-109580030-A&excelToken=new95D0EC221EAC4B9C765EA4F7B42957A0EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN104589674A',row2:'CN201510076710.7', row3: '2015-02-13',row4: '飞机用复合材料低成本简易模具及快速制造方法',row5: '哈尔滨新科锐工艺装备制造有限公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-104589674-A&excelToken=new807C059DAB78F03D90561B420CAE2A4FEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN102489802A',row2:'CN201110429417.6', row3: '2011-12-20',row4: '一种微冲压模具原位制造装置',row5: '哈尔滨广播器材有限责任公司',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-102489802-A&excelToken=newE1CB3D4D8E7E9BCEE0AA8944382B1E62EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN116707689A',row2:'CN202310818506.2', row3: '2023-07-05',row4: '一种中波广播发射机的监测设备布点方法及系统',row5: '哈尔滨广播器材有限责任公司',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-116707689-A&excelToken=newC9D32C9F519AB25AC372A28E417C6862EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN111863606A',row2:'CN202010735237.X', row3: '2020-07-28',row4: '一种抗辐射功率晶体管及其制备方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-111863606-A&excelToken=newD15E76FA9D237B702332B55DA15C60CAEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN111863607A',row2:'CN202010735238.4', row3: '2020-07-28',row4: '一种抗辐射功率晶体管及其制备方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-111863607-A&excelToken=newC3D680D34CA54788D34AEFE19D5536B7EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN115856397A',row2:'CN202211582488.4', row3: '2022-12-09',row4: '一种等离子点火系统的放电电压测量辅助工具',row5: '哈尔滨工程大学',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-115856397-A&excelToken=new895EE6C91ED9DFDA86181D7A54E331C2EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN102868908A',row2:'CN201110184906.X', row3: '2011-07-04',row4: '高效流媒体播放方法和装置',row5: '哈尔滨融智达网络科技有限公司',row6:'失效',link:'https://www.himmpat.com/browse?ucid=CN-102868908-A&excelToken=new0056449D541574EEC958234B31910448EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN108964731A',row2:'CN201810966467.X', row3: '2018-08-23',row4: '基于快速卷积的无循环前缀滤波混合载波连续流传输方法',row5: '哈尔滨工业大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-108964731-A&excelToken=new8CB7D18F2A917062E55B3C34CC0A69DBEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN108956742A',row2:'CN201810820855.7', row3: '2018-07-24',row4: '一种石墨烯场效应晶体管阵列生物传感器及其制备方法和检测方法',row5: '哈尔滨工程大学 | 中国电子科技集团公司第四十九研究所',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-108956742-A&excelToken=newFA6245DBEF0B816E2300CC28431E517CEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN101481475B',row2:'CN200810023192.2', row3: '2008-07-17',row4: '紫外光交联膨胀型阻燃聚烯烃电缆绝缘护套料及制备方法',row5: '黑龙江省润特科技有限公司 | 中国科学技术大学',row6:'有效',link:'https://www.himmpat.com/browse?ucid=CN-101481475-B&excelToken=new54775C4BE5DA4D2CDC96AD8748464B3EEF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
      {row1: 'CN101434728A',row2:'CN200810244782.8', row3: '2008-12-04',row4: '紫外光交联三元乙丙橡胶电缆绝缘料及其制备方法',row5: '黑龙江省润特科技有限公司 | 中国科学技术大学',row6:'有效',link: 'https://www.himmpat.com/browse?ucid=CN-101434728-A&excelToken=newFF6A1F18DFBBCD225F9DEC5F02B6F6C2EF7782E4BA50F8BAF976C5F3BAF4813C_089F229309E26EB66CDFFFFBC68DAAB2'},
    ])
    function clearScrll() {
      clearInterval(timer)
      timer = null;
    }
    function scrollUp() {
         nextTick(()=>{
          const myTab = myTable.value.$refs.bodyWrapper.getElementsByClassName('el-scrollbar__wrap')[0];
          const tableScroll = ref(true);
          myTab.addEventListener('mouseover',()=>{
            tableScroll.value = false;
          })
          myTab.addEventListener('mouseout',()=>{
            tableScroll.value = true;
          })
          timer = setInterval(()=>{
            if(tableScroll.value) {
              myTab.scrollTop += 1;
              if(myTab.clientHeight + myTab.scrollTop >= myTab.scrollHeight) {
                myTab.scrollTop = 0;
              }
            }
          },150)
         })
    }
    onMounted(() => {
      scrollUp();
    });
    onUnmounted(() => {
      clearScrll();
    });
    return {tableData2, scrollUp, myTable, clearScrll,timer};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table{
  color: #fff;
  text-align: center;
}
.table div.text{
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.table-data{
  overflow: hidden;
}
.el-table :deep()tr{
  background-color: transparent!important;
  border: none;

}
.el-table {
  background-color:  transparent!important;
}
.el-table :deep() tr th{
background-color: transparent!important;
border: none!important;
font-size: 16px;
color: #2C6AE8;
}
.el-table :deep() tr td{
  border: none!important;
  color: #80D9FB;
  font-size: 16px;
}
.tablebox{
  margin-top: 15px;
}
.el-table :deep() tr {border: none!important;}
.el-table :deep()tbody tr:hover>td { background-color:#000746!important;}
.el-table__body tr.hover-row>td { background-color: #000746;}
</style>
<style>
.myTooltips{
  font-size: 16px!important;
  max-width: 200px;
}
</style>
